module.exports = window.globalVar;